var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-product-orders"},[_c('orders-table',{ref:"ordersTable",on:{"closePopup":_vm.treatUnusedMethods}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }